module.exports = __webpack_public_path__ + "img/p1.580a755b.png";